{
  "version": 1,
  "asset_id": "0d2d1ad2-424a-4a85-988f-f386244e4f0b",
  "project_id": "115256dd-a6cc-4bc1-95c1-d787d4c0e481",
  "url": "/__l5e/assets-v1/0d2d1ad2-424a-4a85-988f-f386244e4f0b/wheels-thumb.webp",
  "r2_key": "a/v1/115256dd-a6cc-4bc1-95c1-d787d4c0e481/0d2d1ad2-424a-4a85-988f-f386244e4f0b/wheels-thumb.webp",
  "original_filename": "wheels-thumb.webp",
  "size": 3976,
  "content_type": "image/webp",
  "created_at": "2026-07-28T02:25:08Z"
}
